import { RolePermissionObjects } from "./rolePermissionObjects.constants";

export const segsRouteConfig = [
    {
        routerLink: "/dashboard/segs/seg",
        title: "SEGs",
        objectId: RolePermissionObjects.SEG,
    },
    {
        routerLink: "/dashboard/segs/agent",
        title: "Agents",
        objectId: RolePermissionObjects.Agent,
    },
    {
        routerLink: "/dashboard/segs/agent-group",
        title: "Agent Groups",
        objectId: RolePermissionObjects.AgentGroup,
    },
    {
        routerLink: "/dashboard/segs/jurisdiction",
        title: "Jurisdictions",
        objectId: RolePermissionObjects.Jurisdiction,
    },
    {
        routerLink: "/dashboard/segs/task",
        title: "Tasks",
        objectId: RolePermissionObjects.TaskGroup,
    },
    {
        routerLink: "/dashboard/segs/location",
        title: "Locations",
        objectId: RolePermissionObjects.LocationGroup,
    },
    {
        routerLink: "/dashboard/segs/ppe",
        title: "PPEs",
        objectId: RolePermissionObjects.Ppe,
    },
    {
        routerLink: "/dashboard/segs/analytical-method",
        title: "Analytical Method",
        objectId: RolePermissionObjects.AnalyticalMethod,
    },
    {
        routerLink: "/dashboard/segs/sample-media",
        title: "Media",
        objectId: RolePermissionObjects.SampleMedia,
    },
    {
        routerLink: "/dashboard/segs/oel-type",
        title: "OEL Type",
        objectId: RolePermissionObjects.OelType,
    },
    {
        routerLink: "/dashboard/segs/controls",
        title: "Controls",
        objectId: RolePermissionObjects.Control,
    },
    {
        routerLink: "/dashboard/segs/report-template",
        title: "Report Templates",
        objectId: RolePermissionObjects.ReportTemplate,
    },
];
